// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__mZzX6","select":"styles_select__1Uzl8"};